export const socialMediaComposerArticle = {
  title: 'Social Media Planner: Composer & Scheduling',
  slug: 'social-media-composer',
  content: `Social Media Planner: Composer & Scheduling

Draft, schedule, and edit posts from the composer.

1) Open the composer
- Use the Create button in the planner or the compose query string.

2) Set platform and timing
- Choose the social platform and schedule date/time.
- Save as draft or schedule immediately.

3) Edit scheduled posts
- Open a post from Calendar or Queue to update content or timing.

4) Status tracking
- Scheduled and published statuses update automatically in the queue.
`,
};
